"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Main = require("./Main.style");
var _ErrorMessage = _interopRequireDefault(require("../../../ErrorMessage"));
var _WidthWrapper = _interopRequireDefault(require("../../../WidthWrapper"));
var _Nav = require("../../Nav.style");
var _Header = _interopRequireDefault(require("../Header"));
var _NavPanel = _interopRequireDefault(require("../NavPanel"));
var _SearchPanel = _interopRequireDefault(require("../SearchPanel"));
const Main = _ref => {
  let {
    showSearch,
    showHamburgerMenu,
    isSearchShowing,
    isMenuOpen,
    menuItems,
    onMenuToggle,
    onSearchToggle,
    closeSearch,
    fetchError,
    reload,
    ModalComp,
    openChangePasswordModal
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Main.MobileNavWrapper, null, /*#__PURE__*/_react.default.createElement(_WidthWrapper.default, {
    isMobile: true
  }, fetchError ? /*#__PURE__*/_react.default.createElement(_Nav.ErrorMessageWrapper, null, /*#__PURE__*/_react.default.createElement(_ErrorMessage.default, {
    message: "HeaderMenus.LoadError",
    onAction: reload
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Header.default, {
    showHamburgerMenu: showHamburgerMenu,
    menuItems: menuItems,
    showSearch: showSearch,
    onMenuToggle: onMenuToggle,
    onSearchToggle: onSearchToggle,
    isSearchShowing: isSearchShowing,
    isMenuOpen: isMenuOpen
  }), /*#__PURE__*/_react.default.createElement(_SearchPanel.default, {
    onClose: closeSearch,
    isShowing: isSearchShowing
  }), /*#__PURE__*/_react.default.createElement(_NavPanel.default, {
    show: isMenuOpen,
    menuItems: menuItems,
    onClose: onMenuToggle,
    ModalComp: ModalComp,
    openChangePasswordModal: openChangePasswordModal
  }))));
};
var _default = exports.default = Main;